import Vue from "vue"

/**
 * ======================================================================
 *  STATE
 * ======================================================================
 */

const state = {
    checked: {}
}

/**
 * ======================================================================
 *  GETTERS
 * ======================================================================
 */

const getters = {
  getChecked: state => {
    return state.checked
  }
}

/**
 * ======================================================================
 *  MUTATIONS
 * ======================================================================
 */

const mutations = {
    setChecked(state, data) {
        state.checked = data
    }
}

/**
 * ======================================================================
 *  ACTIONS
 * ======================================================================
 */

const actions = {
    setChecked({ commit }, data) {
         commit("setChecked", data)
    }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
